import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
declare let $: any;

@Component({
  selector: 'app-advertising',
  templateUrl: './advertising.component.html',
  styleUrls: ['./advertising.component.css'],
})
export class AdvertisingComponent implements OnInit {
  strSession: string = '';
  iSystemUser: number = 0;

  lst_Result: any = [];
  lst_Result_Backup: any = [];
  advForm: FormGroup = new FormGroup({});
  editMode: boolean = false;
  submitted: boolean = false;

  constructor(
    private _gurd: GurdServiceService,
    private _other: OtherService,
    private _tooltip: NotificationService,
    private _router: Router,
    private _formBuilder: FormBuilder
  ) { }

  async ngOnInit() {
    this.strSession = this._gurd.decrypt(localStorage.getItem('Session')!);
    this.iSystemUser = Number(this._gurd.decrypt(localStorage.getItem('ID')!));

    this.advForm = this._formBuilder.group({
      strSession: new FormControl(this.strSession),
      iSystemUser: new FormControl(this.iSystemUser),
      iAdvertise: new FormControl(0),
      strTitle: new FormControl('', Validators.required),
      strDate_Start: new FormControl('', Validators.required),
      strDate_End: new FormControl('', Validators.required),
      strURL: new FormControl('', Validators.required),
      strImage: new FormControl('', Validators.required),
    });

    await this.getList();
  }

  async getList() {
    this._other.Showspinner();
    let model = {
      strSession: this.strSession,
      iSystemUser: this.iSystemUser,
    };
    try {
      let res = JSON.parse((await axios.post('Advertise_List', this._other.stringNumberToNumber(model))).data.toString());
      this._other.nonespinner();
      if (res.ISSessionExpired == true) {
        this._tooltip.showError('لطفا وارد سیستم شوید');
        this._other.removeLocalStorage();
        this._router.navigate(['login'], {
          queryParams: { error: 'لطفا وارد سیستم شوید' },
        });
        return;
      }
      if (res.iResult == 0) {
        return this._tooltip.showError(res.strError);
      }
      this.lst_Result = res;
      this.lst_Result_Backup = res;
    } catch (error) {
      this._other.nonespinner();
      this._tooltip.showError('خطا در دریافت اطلاعات');
    }
  }

  filter_Result(value: string): void {
    const query = (value ?? '')
      .toString()
      .trim()
      .toLocaleLowerCase()
      .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 1776))
      .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 1632));

    if (!query) {
      this.lst_Result = this.lst_Result_Backup;
      return;
    }

    const searchableKeys = ['strTitle', 'strDate_Start', 'strDate_End', 'strDate_Save'];

    this.lst_Result = this.lst_Result_Backup.filter((item: any) =>
      searchableKeys.some((key) =>
        (item?.[key] ?? '')
          .toString()
          .toLocaleLowerCase()
          .includes(query)
      )
    );
  }

  imagePreview(): string {
    const val = this.advForm.get('strImage')?.value;
    if (!val) {
      return '';
    }
    if (val.startsWith('data:image')) {
      return val;
    }
    if (val.startsWith('iVBOR')) {
      return 'data:image/png;base64,' + val;
    }
    return 'data:image/jpeg;base64,' + val;
  }

  openAdd() {
    this.advForm.reset();
    this.advForm.controls['strSession'].setValue(this.strSession);
    this.advForm.controls['iSystemUser'].setValue(this.iSystemUser);
    this.advForm.controls['iAdvertise'].setValue(0);
    this.editMode = false;
    this.submitted = false;
    $('#advertise_Modal').modal('show');
  }

  openEdit(item: any) {
    this.editMode = true;
    this.advForm.controls['iAdvertise'].setValue(item.iAdvertise);
    this.advForm.controls['strTitle'].setValue(item.strTitle);
    this.advForm.controls['strDate_Start'].setValue(item.strDate_Start);
    this.advForm.controls['strDate_End'].setValue(item.strDate_End);
    this.advForm.controls['strURL'].setValue(item.strURL);
    this.advForm.controls['strImage'].setValue(item.strImage);
    this.submitted = false;
    $('#advertise_Modal').modal('show');
  }

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    const allowed = ['image/jpeg', 'image/png'];
    if (allowed.indexOf(file.type) === -1) {
      this._tooltip.showError('فقط فرمت های jpg و png مجاز می باشد');
      event.target.value = '';
      return;
    }
    const reader: any = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const base64String = reader.result.toString();
      this.advForm.controls['strImage'].setValue(
        base64String
          .replace('data:image/jpeg;base64,', '')
          .replace('data:image/png;base64,', '')
      );
    };
  }

  async submit() {
    this.submitted = true;
    if (this.advForm.invalid) {
      this.advForm.markAllAsTouched();
      this._tooltip.showError('فرم را با دقت تکمیل کنید');
      return;
    }
    this._other.Showspinner();
    let model = this.advForm.value;
    let api = this.editMode ? 'Advertise_Edit' : 'Advertise_Save';
    try {
      let res = JSON.parse(
        (
          await axios.post(api, this._other.stringNumberToNumber(model))
        ).data.toString()
      );
      this._other.nonespinner();
      if (res.ISSessionExpired == true) {
        this._tooltip.showError('لطفا وارد سیستم شوید');
        this._other.removeLocalStorage();
        this._router.navigate(['login'], {
          queryParams: { error: 'لطفا وارد سیستم شوید' },
        });
        return;
      }
      if (res.iResult == 0) {
        return this._tooltip.showError(res.strError);
      }
      this._tooltip.showSuccess('اطلاعات با موفقیت ثبت شد');
      $('#advertise_Modal').modal('hide');
      await this.getList();
    } catch (error) {
      this._other.nonespinner();
      this._tooltip.showError('خطا در ثبت اطلاعات');
    }
  }

  delete(item: any) {
    $.confirm({
      title: 'حذف',
      content: 'آیا از حذف این مورد اطمینان دارید؟',
      rtl: true,
      buttons: {
        confirm: {
          text: 'بله',
          btnClass: 'btn-red',
          action: async () => {
            this._other.Showspinner();
            let model = {
              strSession: this.strSession,
              iSystemUser: this.iSystemUser,
              iAdvertise: item.iAdvertise,
            };
            try {
              let res = JSON.parse(
                (
                  await axios.post(
                    'Advertise_Delete',
                    this._other.stringNumberToNumber(model)
                  )
                ).data.toString()
              );
              this._other.nonespinner();
              if (res.ISSessionExpired == true) {
                this._tooltip.showError('لطفا وارد سیستم شوید');
                this._other.removeLocalStorage();
                this._router.navigate(['login'], {
                  queryParams: { error: 'لطفا وارد سیستم شوید' },
                });
                return;
              }
              if (res.iResult == 0) {
                return this._tooltip.showError(res.strError);
              }
              this._tooltip.showSuccess('با موفقیت حذف شد');
              await this.getList();
            } catch (error) {
              this._other.nonespinner();
              this._tooltip.showError('خطا در حذف');
            }
          },
        },
        cancel: {
          text: 'خیر',
        },
      },
    });
  }
}
